import React from "react";
import { Box, IconButton, useMediaQuery } from '@mui/material';
import ImportExport from '@mui/icons-material/ImportExport';
import { AppButton } from "../../components/UI";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import peoplefineLogo from "../../assets/images/goandev-logo.png";
import { theme } from "../../utils/Theme";

export const DownloadPDFFile = ({ csvData, fileName, clientName }) => {
  const exportToPDF = () => {
    const doc = new jsPDF("landscape");
    const tableColumnTitles = [
      "N°",
      "NOM",
      "SOURCEUR",
      "TALENT MANAGER",
      "DELIVERY MANAGER",
      "CLIENT",
      "MISSION",
      "PREQUALIF RH",
      "TEST INTERNE",
      "ENVOI CLIENT",
      "RV CLIENT",
      "RV CLOSING",
      "EMBAUCHE",
      "INTÉGRATION",
    ];
    const csvDataSorted = csvData.sort((a, b) => {
      const date1 = a.sent;
      const date2 = b.sent;

      if (date1 < date2) {
        return -1;
      }
      if (date1 > date2) {
        return 1;
      }
      return 0;
    });


    const tableData = csvDataSorted.map((value, index) => {
      return [
        index + 1,
        value.nom,
        value.sourceur,
        value.consultant,
        value.manager,
        value.nom_societe,
        value.nom_mission,
        value.dateAccrochage ? moment(value.dateAccrochage?.date).format("DD/MM/yyyy") : "-",
        (value.testTechniqueAt?.date || value.rvTech?.date) ? moment(value.testTechniqueAt?.date || value.rvTech.date).format("DD/MM/yyyy") : "-",
        value.sent ? moment(value.sent?.date).format("DD/MM/yyyy") : "-",
        value.rvClient ? moment(value.rvClient?.date).format("DD/MM/yyyy") : "-",
        value.rvClosing ? moment(value.rvClosing?.date).format("DD/MM/yyyy") : "-",
        value.dateEmbauche ? moment(value.dateEmbauche).format("DD/MM/yyyy") : "-",
        value.dateIntegration ? moment(value.dateIntegration).format("DD/MM/yyyy") : "-",
      ];
    });
    const logoWidth = 50;
    const logoX = 13;
    const logoY = 8;
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.addImage(peoplefineLogo, "PNG", logoX, logoY - 1, logoWidth, 15);

    let title = `REPORTING GOANDEV - ${clientName} - ${moment().format(
      "D/MM/YYYY"
    )}`;
    if (!clientName) {
      title = `REPORTING GOANDEV - ${moment().format("D/MM/YYYY")}`;
    }

    const titleWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;

    const startX = (pageWidth - titleWidth) / 2;
    doc.setFont("bold");
    doc.text(title, startX, 25);
    doc.setFontSize(12);

    const headerText = "";
    // const headerText = "Statut: A (Active) / P (Passive)";
    const headerTextWidth = doc.getStringUnitWidth(headerText) * 10;
    const headerX = pageWidth - headerTextWidth + 70;
    const headerY = 10;

    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text(headerText, headerX, headerY);
    doc.autoTable({
      head: [tableColumnTitles],
      body: tableData,
      startY: 30,
      theme: "grid",
      styles: { fontSize: 8, valign: "middle", halign: "center" },
      headStyles: {
        fillColor: "#ffffff",
        textColor: "#000",
        lineWidth: 0.1,
        lineColor: "#000",
        fontSize: 8,
        valign: "middle",
        halign: "start",
      },
      bodyStyles: {
        halign: "start",
        valign: "middle",
        fontSize: 8,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      cellStyles: { overflow: "linebreak", fontSize: 9 },
    });


    doc.setTextColor(0);

    const addressText1 = "Adr: 8 av. Duval Le Camus 92210 Saint Cloud" ;
    const addressText2 = "Villa 4, Rue Arrommane, Hay Riad, Rabat 10100" ;
    const emailText = "Email: contact@goandev.net";
    const siteWeb = "Site: https://www.goandev.net/";
    const phone1 = "Tél: +33 (0)1 80 88 34 91";
    const phone2 = "+212 652 084 058";

    const footerTexts = [addressText1, addressText2, emailText, siteWeb, phone1, phone2];
    const startY = doc.internal.pageSize.getHeight() - 30;

    footerTexts.forEach((text, index) => {
      const y = startY + (index * 5);
      const x = 138 - (doc.getStringUnitWidth(text) * 2);
      doc.text(text, x, y);
    });

    doc.save(`REPORTING GOANDEV-${clientName}-${fileName}.pdf`);
  };

  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));

  return (
      <Box sx={{ display: "flex" }}>
      {!isSmMode ? (
        <AppButton variant="primary" startIcon={<ImportExport />} onClick={exportToPDF}>
          Exporter
        </AppButton>
      ) : (
        <IconButton title="Exporter" onClick={exportToPDF} size="medium" sx={{ background: '#ebf4fb', color: '#03407b', borderRadius: '10px' }}>
          <ImportExport />
        </IconButton>
      )}
    </Box>
  );
};

export default DownloadPDFFile;
